import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/illustrations/main-signup.png")